import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import { DeviceDTO, FunctionType } from '@/../client-generator/generated-clients/plants';

@Options({
  name: 'PlantDashboardDevices',
  props: {
    devices: {
      type: Object as PropType<DeviceDTO[]>,
      required: true,
    },
    lastScanDate: {
      type: String,
      required: true,
    },
    lastScanTime: {
      type: String,
      required: true,
    },
  },
})
export default class PlantDashboardDevices extends Vue {
  devices!: DeviceDTO[];

  get devicesNo() {
    return this.devices.length;
  }

  get devicesNoAssigned() {
    return this.devices.filter((d) => !!d.isAssigned).length;
  }

  get devicesNoNotAssigned() {
    return this.devices.filter((d) => !d.isAssigned).length;
  }

  get thermoDevicesNo() {
      return this.devices.filter(d => d.functionType === FunctionType.Thermo).length;
  }

  get automationDevicesNo() {
      return this.devices.filter(d => d.functionType === FunctionType.Automation).length;
  }

  get energyDevicesNo() {
      return this.devices.filter(d => d.functionType === FunctionType.Energy).length;
  }

  get securityDevicesNo() {
      return this.devices.filter(d => d.functionType === FunctionType.Security).length;
  }

  goToDevices() {
    this.$router.push({
      name: 'page-plant-devices',
    });
  }
}
